import { AnalyzerRule } from './valueObjects/AnalyzerRule';

export class FuzzerRule extends AnalyzerRule {}
